import { useTranslation } from 'react-i18next'
import React from 'react'
import { AlertUnauthContext } from 'src/pages/model'

export const useUnAuthAlert = () => {
  const { t } = useTranslation()
  const openUnAuthAlertMemo = React.useContext(AlertUnauthContext)

  const openUnAuthAlertMemoWithContent = () => {
    openUnAuthAlertMemo({
      title: t('alert.authOverDueTitle'),
      content: t('alert.authOverDueDesc'),
      isDicidedMode: false,
      confirmBtnLabel: t('alert.authOverDueBtn'),
      onClose: () => {
        window.location.href = '/'
      },
    })
  }

  return { openUnAuthAlertMemoWithContent }
}
